export default __webpack_public_path__ + "static/media/text.62a0880c.svg";